import { Sparkles } from "lucide-react";
import { MasterRenStage } from "./components/MasterRenStage";
import { foundationItems, stations } from "./data/stations";

export function App() {
  return (
    <main className="page-shell">
      <header className="site-header" aria-label="TupTrader.ir">
        <a className="brand" href="#top" aria-label="TupTrader">
          <span className="brand-mark">T</span>
          <span>TupTrader</span>
        </a>
        <nav className="nav-links" aria-label="Primary">
          <a href="#roadmap">مسیر رشد</a>
          <a href="#academy">آکادمی</a>
          <a href="#hermes">مستر رن</a>
          <a href="#trust">اعتماد</a>
        </nav>
        <a className="login-link" href="#dashboard">
          ورود
        </a>
      </header>

      <MasterRenStage />

      <section id="roadmap" className="roadmap-section">
        <div className="section-heading">
          <Sparkles aria-hidden="true" />
          <h2>مسیر رشد معامله‌گر ایرانی</h2>
        </div>
        <div className="station-line">
          {stations.map((station) => {
            const Icon = station.icon;
            return (
              <a className="station" href={`#${station.code}`} key={station.code}>
                <span className="station-icon">
                  <Icon aria-hidden="true" />
                </span>
                <strong>{station.label}</strong>
                <small>{station.summary}</small>
              </a>
            );
          })}
        </div>
      </section>

      <section id="academy" className="foundation-section">
        <div className="foundation-copy">
          <h2>پایه‌های فنی آماده شد</h2>
          <p>
            سورس استخراج‌شده محتوای فارسی آکادمی، داده‌های PRISM، قراردادهای
            پلتفرم و الگوی دسترسی‌ها را دارد. این نسخه جدید سطح محصول را کوچک،
            روشن و از ابتدا serverless نگه می‌دارد.
          </p>
        </div>
        <div className="foundation-grid">
          {foundationItems.map((item) => (
            <article className="foundation-card" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section id="trust" className="trust-section">
        <h2>شفافیت، مسئولیت‌پذیری و امنیت داده</h2>
        <p>
          PRISM، ژورنال و مستر رن برای مرور، یادگیری و رشد طراحی شده‌اند. این
          ابزارها وعده سود نمی‌دهند، جایگزین تصمیم مالی کاربر نیستند و داده
          خصوصی کاربر را بدون طراحی دسترسی روشن نباید آشکار کنند.
        </p>
      </section>
    </main>
  );
}
